import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Loading() {
	const { t } = useTranslation();

	return (
		<div className="d-flex flex-column justify-content-center align-items-center text-center gap-2 vh-100">
			<div className="spinner-grow" role="status" />

			<div>
				<strong>{t('The page is loading')}</strong>
			</div>

			<div className="px-2 mb-4">
				{t(
					'Please contact support or refresh if this page does not redirect in 1 minute'
				)}
			</div>
		</div>
	);
}
